import * as types from 'misc/types';
import * as actions from 'misc/actions';

const government_list = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_GOVERNMENT_LIST_GET.REQUEST:
            return actions.load(state);
        case types.SAGA_GOVERNMENT_LIST_GET.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_GOVERNMENT_LIST_GET.FAILURE:
            return actions.error(state, action.error);

        case types.SAGA_GOVERNMENT_LIST_PUT.REQUEST:
            return actions.load(state);
        case types.SAGA_GOVERNMENT_LIST_PUT.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_GOVERNMENT_LIST_PUT.FAILURE:
            return actions.error(state, action.error);


        default:
            return state;
    }
};

export default government_list;



// WEBPACK FOOTER //
// ./src/reducers/government_list.js